import React from 'react';
import { TitleHeader } from 'web-library';
import { useTranslation } from 'react-i18next';
import TransactionHistorySubjectAmendment from '../../modules/subject/components/TransactionHistorySubjectAmendment';

const TransactionHistoryAmendmentPage = () => {
  const { t } = useTranslation();
  return (
    <>
      <TitleHeader title={t('amendment->>SubjectAmendment.View Registration')} />
      <TransactionHistorySubjectAmendment />
    </>
  );
};

export default TransactionHistoryAmendmentPage;
